<template>
  <div class="container">
    <div class="left">
      <div class="menu">
        <div class="active">
          <span>基本信息</span>
        </div>
        <div @click="go(`/user/safe/list`)">
          <span>安全中心</span>
        </div>
        <div @click="go(`/user/default-corp`)">
          <span>设置默认企业</span>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="sub-page">
        <div class="sub-page-title">
          基本信息
        </div>
        <div class="sub-page-content">
          <div class="form active">
            <Form2ItemInput
              v-model="form.username"
              ref="username"
              label="用户名"
              :required="true"
              max="50"
              :rule="[{ required: true, message: `用户名不能为空` }]"
            />
            <Form2ItemInput
              v-model="form.email"
              ref="email"
              label="邮箱"
              placeholder="请输入邮箱"
              max="50"
              :rule="[
                { pattern: pattern.email, message: `邮箱格式不正确`, trigger: `blur`},
                { min: 0, max: 50, message: `邮箱格式不正确`, trigger: `blur`}
              ]"
            />
            <Form2ItemInput
              v-model="form.wechat"
              ref="wechat"
              type="text"
              label="微信"
              placeholder="请输入微信"
              max="30"
              :rule="[
                { min: 0, max: 30, message: `长度不能超过30个字符`, trigger: `blur`}
              ]"
            />
            <Form2ItemInput
              v-model="form.qq"
              ref="qq"
              type="text"
              label="QQ"
              placeholder="请输入QQ"
              max="30"
              :rule="[
                { pattern: pattern.positiveInt, message: `长度不能超过30个字符，且为数字`, trigger: `blur`},
                { min: 0, max: 30, message: `长度不能超过30个字符，且为数字`, trigger: `blur`}
              ]"
            />
            <div>
              <a
                class="button"
                href="javascript:;"
                @click="submit">保存</a>
            </div>
          </div>
          <div class="form">
            <Form2ItemInput
              v-model="form.avatar"
              ref="avatar"
              type="file"
              label="头像" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form2ItemInput from '@/components/form2-item-input';
import {editUserInfo} from '@/service';
import pattern from '@/util/pattern';
export default {
  name: 'UserInfo',
  components: {Form2ItemInput},
  data() {
    return {
      pattern,
      form: {},
    };
  },
  watch: {
    '$store.state.user.user'(n, o) {
      const nV = JSON.stringify(n);
      const oV = JSON.stringify(o);
      if (nV === oV) return;
      this.form = JSON.parse(nV);
    },
  },
  methods: {
    go(path) {
      this.$router.push(path);
    },
    submit() {
      Promise.all([
        this.$refs['username'].validate(),
        this.$refs['email'].validate(),
        this.$refs['wechat'].validate(),
        this.$refs['qq'].validate(),
        this.$refs['avatar'].validate(),
      ]).then(([valid1, valid2, valid3, valid4, valid5]) => {
        if (valid1 && valid2 && valid3 && valid4 && valid5) {
          editUserInfo(this.form).then(({resultDesc}) => {
            this.$Message.success(resultDesc);
            this.$store.dispatch('user/init');
          });
        }
      });
    },
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.$store.state.user.user));
  },
};
</script>

<style lang="scss">
  .sub-page {
    flex: 1;
    .sub-page-content {
      .form {
        &.active {
          padding-left: 0 !important;
        }
      }
    }
    &-title {
      color: rgba(0, 0, 0, 0.85);
    }
    .button {
      width: 64px;
      height: 32px;
      padding: 0 !important;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
